import React from 'react';
import type { RegistrationReviewCounts } from '../../types/event';

interface EventRosterSummaryProps {
  counts: RegistrationReviewCounts;
  capacity?: number | null;
  className?: string;
}

const CHIPS: Array<{ key: keyof RegistrationReviewCounts; label: string; highlight?: boolean }> = [
  { key: 'pending_approval', label: 'Pending review', highlight: true },
  { key: 'awaiting_payment', label: 'Awaiting payment' },
  { key: 'confirmed', label: 'Confirmed' },
  { key: 'checked_in', label: 'Checked in' },
  { key: 'rejected', label: 'Rejected' },
  { key: 'withdrawn', label: 'Withdrawn' },
];

const EventRosterSummary: React.FC<EventRosterSummaryProps> = ({ counts, capacity, className = '' }) => {
  return (
    <div className={`space-y-3 ${className}`}>
      <div className="flex flex-wrap gap-2">
        {CHIPS.map(({ key, label, highlight }) => {
          const value = counts[key] ?? 0;
          if (value === 0 && !highlight) return null;
          return (
            <span
              key={key}
              className={`inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1.5 rounded-full border ${
                highlight && value > 0
                  ? 'bg-amber-950/40 text-amber-300 border-amber-800'
                  : 'bg-[#111] text-gray-300 border-white/[0.08]'
              }`}
            >
              <span>{label}</span>
              <span className="tabular-nums text-white">{value}</span>
            </span>
          );
        })}
        <span className="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1.5 rounded-full border bg-[#111] text-gray-300 border-white/[0.08]">
          <span>Total applications</span>
          <span className="tabular-nums text-white">{counts.applications}</span>
        </span>
      </div>
      {(capacity != null || counts.capacity_remaining != null) && (
        <p className="text-xs text-gray-500">
          {capacity != null ? (
            <>Capacity: {capacity} vehicles</>
          ) : null}
          {counts.capacity_remaining != null ? (
            <span className={capacity != null ? ' · ' : ''}>
              {counts.capacity_remaining} spots remaining
            </span>
          ) : null}
        </p>
      )}
    </div>
  );
};

export default EventRosterSummary;
